import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeThird';
const args = {};

export class ModeThird extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
